import React from "react";
import { Heading, makeClassName, Modal, ModalProps } from "@hex-insights/core";
import { CourseAssessmentCustomForm } from "../../../Forms";
import styles from "./styles.module.css";

export type CourseAssessmentCreateModalProps = Partial<
	Pick<CourseAssessmentCustomForm.ControlledCreateProps, "formStateArgs" | "onSuccess" | "formNameSuffix">
> &
	Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function CourseAssessmentCreateModal({
	formStateArgs,
	onSuccess,
	formNameSuffix,
	ifRef,
	onClose,
	className,
	style,
}: CourseAssessmentCreateModalProps) {
	const fullOnSuccess = React.useCallback<CourseAssessmentCustomForm.ControlledCreateProps["onSuccess"]>(
		(...args) => {
			onSuccess?.(...args);
			onClose?.();
		},
		[onSuccess, onClose],
	);

	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>Create New Assessment</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<CourseAssessmentCustomForm.ControlledCreate
					formStateArgs={formStateArgs}
					onSuccess={fullOnSuccess}
					formNameSuffix={formNameSuffix}
				/>
			</Modal.Body>
		</Modal>
	);
}
